import type { ReactNode } from 'react';
import { Panel, ListableInfo } from '@ics-portal/guardian';
import { type ComponentVendorAssessment } from '@gql/graphql';
import { type Maybe } from '@models/Maybe';
import {
    vendorAssessmentResult,
    vendorAssessmentStatus,
    vendorAssessmentType,
} from './helpers/mappings';

interface VendorProps {
    vendorName?: Maybe<string>;
    assessments?: Maybe<ComponentVendorAssessment[]>;
}

export function VendorAssessment({
    vendorName,
    assessments,
}: VendorProps): ReactNode {
    if (!vendorName) {
        return null;
    }

    return (
        <Panel header="Vendor evaluation">
            {assessments?.length ? (
                assessments.map((assessment) => {
                    return (
                        <div key={assessment.id}>
                            <div className="flex flex-column gap-2 pt-sm pb-lg">
                                <ListableInfo
                                    size="md"
                                    label="Name"
                                    value={vendorName}
                                />
                                <ListableInfo
                                    size="md"
                                    label="Vendor type"
                                    value={vendorAssessmentType(
                                        assessment.type,
                                    )}
                                />
                                <ListableInfo
                                    size="md"
                                    label="Assesment status"
                                    value={vendorAssessmentStatus(
                                        assessment.status,
                                    )}
                                />
                                <ListableInfo
                                    size="md"
                                    label="Assesment result"
                                    value={vendorAssessmentResult(
                                        assessment.result,
                                    )}
                                />
                            </div>
                        </div>
                    );
                })
            ) : (
                <p>No vendor type has been assigned to this vendor yet.</p>
            )}
        </Panel>
    );
}
